/**
 * Resolves/rejects with `promise`, but rejects after `ms` if it hasn't settled.
 * Used to bound the programmatic status change so a stuck SDK call can't hang the
 * auto-available flow. The caller logs and swallows the rejection.
 */
export function raceWithTimeout<T>(promise: Promise<T>, ms: number, label: string): Promise<T> {
    return Promise.race([
        promise,
        new Promise<T>((_, reject) => setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms)),
    ]);
}
